import * as React from "react"

import Layout from "./src/components/Layout"
import { getFallbackPageTitle, getPageSeo } from "./src/utils/page-seo"

import "./src/styles/global.css"

export const onInitialClientRender = () => {
  const isIeBrowser = !!window.MSCompatibleInfo
  if (isIeBrowser) {
    window.location.replace("/ie11.html")
  }
}

export const wrapPageElement = ({ element, props }) => {
  const pathname = props.location?.pathname || props.path || props.uri || "/"
  const seo = getPageSeo({ pathname, pageContext: props.pageContext })
  const pageTitle = seo.title || getFallbackPageTitle(pathname)

  return (
    <Layout title={pageTitle} seo={seo} {...props}>
      {element}
    </Layout>
  )
}
